"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatabaseDisplayString = exports.getConnectionType = exports.getDatabaseName = exports.tableDatabaseCellTitle = exports.tableDatabaseGroupIcon = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
function tableDatabaseName(table) {
    if (table && (table.__typename === 'DatabaseTable') && table.database) {
        return table.database.name;
    }
    return null;
}
function tableDatabaseHostName(table) {
    if (table && (table.__typename === 'DatabaseTable') && table.database && table.database.__typename === 'DatabaseServer') {
        return table.database.hostName;
    }
    return null;
}
function tableFilePath(table) {
    if (table.__typename === 'DatabaseTable' && table.database && table.database.__typename === 'File') {
        return table.database.filePath;
    }
    return null;
}
function tableDatabaseGroupIcon(table) {
    if (table && (table.__typename === 'DatabaseTable') && table.database && table.database.isGrouped) {
        return react_1.default.createElement(catalog_icons_1.SvgGroupPaperclip, null);
    }
    return null;
}
exports.tableDatabaseGroupIcon = tableDatabaseGroupIcon;
function tableDatabaseCellTitle(table) {
    var _a;
    if (table && (table.__typename === 'DatabaseTable') && table.database && table.database.isGrouped) {
        return catalog_messages_1.Messages.GroupedDatabaseTitle({ name: (_a = tableDatabaseName(table)) !== null && _a !== void 0 ? _a : '' });
    }
    return null;
}
exports.tableDatabaseCellTitle = tableDatabaseCellTitle;
function getDatabaseName(table) {
    const databaseName = tableDatabaseName(table);
    const filePath = tableFilePath(table);
    if (filePath) {
        return filePath;
    }
    else if (databaseName) {
        return databaseName;
    }
    else {
        return '';
    }
}
exports.getDatabaseName = getDatabaseName;
function getConnectionType(table) {
    var _a, _b, _c;
    if (((table === null || table === void 0 ? void 0 : table.__typename) === 'DatabaseTable')
        && (((_a = table.database) === null || _a === void 0 ? void 0 : _a.__typename) === 'DatabaseServer'
            || ((_b = table.database) === null || _b === void 0 ? void 0 : _b.__typename) === 'File'
            || ((_c = table.database) === null || _c === void 0 ? void 0 : _c.__typename) === 'DataCloud')) {
        return (0, data_catalog_shared_1.messageForConnectionType)(table.database.connectionType) || '';
    }
    return '';
}
exports.getConnectionType = getConnectionType;
function getDatabaseDisplayString(table) {
    const databaseName = tableDatabaseName(table);
    const databaseHostName = tableDatabaseHostName(table);
    const filePath = tableFilePath(table);
    if (filePath) {
        return filePath;
    }
    else if (databaseName) {
        return databaseHostName
            ? catalog_messages_1.Messages.DatabaseWithHostname({ databaseName: databaseName, databaseHostName: databaseHostName })
            : databaseName;
    }
    else {
        return '';
    }
}
exports.getDatabaseDisplayString = getDatabaseDisplayString;
//# sourceMappingURL=DatabaseNameCell.js.map